if (!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
    constructor() {
    super();
    this.addEventListener('click', this.handleClick);
    }

    handleClick(e) {
    e.preventDefault();   
    const target = e.currentTarget;
    
    document.querySelectorAll('.product_grouping_list_innerloops_new product-swatch').forEach(swatch => {
        swatch.classList.remove('active');
    })
    
    target.classList.add('active');
    const productUrl = this.dataset.productUrl;
    
        // render new contents
        this.renderSections(productUrl)   
    }
    getSectionsToRender() {
        return [
            {
              selector: "js-product-info",
              sectionId: this.closest("[js-product-info]")?.dataset.section
            }
        ]
    }

    getBelowFoldSectionsToRender() {
        return [
            {
              selector: "js-nss-product-meta-gallery-main-new",
              sectionId: document.querySelector("[js-nss-product-meta-gallery-main-new]")?.dataset.section
            },
            {
              selector: "js-nss-reviews-with-images-main-new",
              sectionId: document.querySelector("[js-nss-reviews-with-images-main-new]")?.dataset.section
            },
            {
              selector: "js-stamped-main-widget",
              sectionId: document.querySelector("[js-stamped-main-widget]")?.dataset.section
            }
        ]
    }
    
    renderSections(productUrl) {
        const self = this;
        this.getSectionsToRender().forEach(section=> {

          let url = `${location.origin}${productUrl}?view=product-latest-template-new&section_id=${section.sectionId}`;

           if(section.sectionId != undefined) {
              fetch(`${url}`)
              .then(response=>response.text())
              .then(html=>{
    
                  const doc = new DOMParser().parseFromString(html, "text/html");
                  const productInfoGridAjax = doc.querySelector(`[${section.selector}]`)
                  const elementToReplace = document.querySelector(`[${section.selector}]`);
                    
                  if(elementToReplace && doc.querySelector(`[${section.selector}]`)) {
                      elementToReplace.innerHTML ='';
                      elementToReplace.innerHTML = productInfoGridAjax.innerHTML
                  }                

                  switch (section.selector) {
                    case "js-product-info":
                        const updateUrl = this.closest('[js-main-product-info]').getAttribute('data-update-url');
                        doc.querySelector('[js-main-product-info]').setAttribute('data-update-url', updateUrl);
                        
                        if(window.location.pathname.includes('/products/') && this.closest('[js-main-product-info]').getAttribute('data-update-url') == 'true') {
                          const productName = doc.querySelector('.nss_custom_title_texts_new h1').innerHTML;
                          self.updateHistoryState(productUrl, productName)
                        
                        }

                        document.dispatchEvent(new CustomEvent('product-media-slider:init'));
                        document.dispatchEvent(new CustomEvent('ns-product-review:init'));
                        document.dispatchEvent(new CustomEvent('pdp-accordion:init'))
                        document.dispatchEvent(new CustomEvent('productPageScript:init'));
                        document.dispatchEvent(new CustomEvent('stickyHeight:init'));
                        document.dispatchEvent(new CustomEvent('pdpCustomDropdown:init'));

                        StampedFn.reloadUGC();
                        
                        setTimeout(() => {
                          if (window.theme && typeof theme.Product === 'function') {
                            document.querySelectorAll('[data-section-type="product"]').forEach(container => new theme.Product(container));
                          }
                        }, 500);

                        this.getBelowFoldRenderSections(productUrl);

                    break;
                  }

                 
              }).catch(function(error) {
                  console.log(error)
              })
           }
        }
        )
    }

    getBelowFoldRenderSections(productUrl) {
        const self = this;
        this.getBelowFoldSectionsToRender().forEach(section=> {

          let url = `${location.origin}${productUrl}?view=product-latest-template-new&section_id=${section.sectionId}`;

           if(section.sectionId != undefined) {
              fetch(`${url}`)
              .then(response=>response.text())
              .then(html=>{
    
                  const doc = new DOMParser().parseFromString(html, "text/html");
                  const elementToReplace = document.querySelector(`[${section.selector}]`);

                  console.log({ elementToReplace })
                  console.log('testing: ', doc.querySelector(`[${section.selector}]`))
                  console.log('section.sectionId: ', section.sectionId)

                  if(elementToReplace && doc.querySelector(`[${section.selector}]`)) {
                      elementToReplace.innerHTML ='';
                      elementToReplace.innerHTML = doc.querySelector(`[${section.selector}]`).innerHTML;
                  }

                  switch (section.selector) {
                    case "js-nss-product-meta-gallery-main-new":
                      document.dispatchEvent(new CustomEvent('nssProductGallerySliderInit'));
                    break;
                    case "js-nss-reviews-with-images-main-new":
                      document.dispatchEvent(new CustomEvent('nss-reviews-with-images-slider:init'));
                    break;
                    case "js-stamped-main-widget":
                         setTimeout(() => {
                             StampedFn.reloadUGC();
                         }, 500)
                    break;
                  }
                  

                 
              }).catch(function(error) {
                  console.log(error)
              })
           }
        }
        )
    }
    
    updateHistoryState(productUrl, productName) {
        document.title = productName;
        var newurl = `${window.location.origin}${productUrl}`;
        window.history.replaceState({
            path: newurl
        }, "", newurl)
    }
  }
  
  customElements.define('product-swatch', ProductSwatch);
}